import { getFalseRangeDisplayValue } from "helpers/utility/utilities";
import { useCallback, useState } from "react";

import styles from "./styles.module.scss";
import classNames from "classnames";
import { RANGE_QUERY_MIN_VALUE } from "../../../../helpers/constants/queries";
import VLSlider from "views/uikit/VLSlider";

export interface RangeInputProps {
  title: string;
  range: [number, number];
  showActualValues?: boolean;
  onChange: (range: [number, number]) => void;
  minValue?: number;
}

export default function RangeInput({
  title,
  range,
  showActualValues = false,
  onChange,
  minValue = RANGE_QUERY_MIN_VALUE,
}: RangeInputProps) {
  const [currentRange, setCurrentRange] = useState<[number, number]>(range);

  const dynamicMin = showActualValues ? 0 : minValue;

  const formatTooltip = useCallback(
    (value?: number) => {
      if (value === undefined) {
        return null;
      }
      const display = showActualValues
        ? value
        : getFalseRangeDisplayValue(value, minValue);
      return display;
    },
    [showActualValues, minValue],
  );

  const handleChange = (value: [number, number]) => {
    setCurrentRange(value);
  };

  return (
    <div className={classNames(styles.rangeContainer, "rangeContainer")}>
      <div className={classNames(styles.title, "rangeTitle")}>{title}</div>
      <div className={classNames(styles.label, "rangeLabel")}>0</div>
      <div className={styles.sliderWrapper}>
        <VLSlider
          range
          min={dynamicMin}
          value={currentRange}
          onChange={(value: number | number[]) =>
            handleChange(value as [number, number])
          }
          onChangeComplete={(value: number | number[]) =>
            onChange(value as [number, number])
          }
          className={styles.slider}
          tooltip={{
            open: true,
            formatter: formatTooltip,
          }}
        />
      </div>
      <div className={styles.label}>1</div>
    </div>
  );
}
